import { PlusOutlined, QuestionCircleOutlined } from "@ant-design/icons";

import {
  Button,
  Col,
  DatePicker,
  Divider,
  Drawer,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Tooltip,
} from "antd";
import React, { useEffect, useRef } from "react";
import { useClient } from "../../Context/ClientContext";
import { dayjs } from "../../../Utilities/dayjs";
import { AssetPurType, CalcMethod, ChildAsset, PmtMethod } from "./AssetModel";
import LocationService from "../../Services/LocationService";
import AddLocationModal from "./AddLocationModal";
import {
  handleDecimalValues,
  handleInputFocus,
  Utils,
} from "../../../Utilities/Utils";

const AssetChildDetail = ({
  open,
  onCancel,
  setOpenChildDrawer,
  isDepreciable,
  depMethod,
  refNumber,
  singleAssetType,
  selKey,
  purchaseDate,
  setChildAssetDetail,
  childAssetDetail,
  oldPurchaseType,
  invoiceDetaildata,
  assetName,
}: any) => {
  const { currentClient, companySettings } = useClient();
  const [assetChildForm] = Form.useForm();
  const [assetLocation, setAssetLocation] = React.useState<number>(1);
  const [assetPurDate, setAssetPurDate] = React.useState<any>();
  const [locationList, setLocationList] = React.useState<any[]>([]);
  const [isModelOpen, setIsModelOpen] = React.useState<boolean>(false);
  const [refresh, setRefresh] = React.useState<boolean>(false);
  const [childAssetAvailable, setChildAssetAvailable] =
    React.useState<boolean>(false);
  const [currChildData, setCurrentChildData] =
    React.useState<ChildAsset | null>(null);
  const [locDropdownLoading, setLocDropdownLoading] = React.useState(false);
  const [fyPeriod, setFYPeriod] = React.useState<any>({
    from: dayjs(companySettings?.period?.from),
    to: dayjs(companySettings?.period?.to),
  });

  const [openModel, setOpenModel] = React.useState<{
    type: string;
    param: any;
  }>({
    type: "",
    param: {},
  });

  const handleChildAssetNameDuplicate = async (e: any) => {
    let newChildAssetDetail = childAssetDetail?.filter(
      (led: any) => led.key !== selKey
    );
    let ledDetail = newChildAssetDetail?.filter(
      (led: any) =>
        led.childAssetName.toLowerCase() === e?.target?.value.toLowerCase()
    );
    setChildAssetAvailable(ledDetail?.length! > 0 ? true : false);
  };

  const handleLocation = (selValue: number) => {
    setAssetLocation(selValue);
  };

  useEffect(() => {
    assetChildForm.resetFields();
    let childsLength = childAssetDetail?.length ?? 0;
    let maxKey =
      childAssetDetail.reduce(
        (acc: number, rec: any) => (acc > rec.key ? acc : rec.key),
        0
      ) + 1;
    let selChildAsset = childAssetDetail.find(
      (child: any) => child.key === selKey
    );
    if (
      childsLength > 0 &&
      childAssetDetail.some((child: any) => child.key === selKey)
    ) {
      assetChildForm.setFieldsValue({
        ...selChildAsset,
        childAssetName:
          singleAssetType && assetName
            ? assetName
            : selChildAsset?.childAssetName,
        depreciationStartDate: selChildAsset?.depreciationStartDate
          ? dayjs(selChildAsset?.depreciationStartDate)
          : undefined,
        warrantyExpDate: selChildAsset?.warrantyExpDate
          ? dayjs(selChildAsset?.warrantyExpDate)
          : undefined,
      });
      // setCurrentChildData(childAssetDetail[selKey]);
    } else {
      assetChildForm.setFieldsValue({
        // key: childsLength,
        childAssetName: singleAssetType && assetName ? assetName : "",
        childAssetNumber:
          refNumber +
          "-" +
          (invoiceDetaildata.key + 1).toString().padStart(2, `0`) +
          "-" +
          maxKey.toString().padStart(2, `0`),
        lifeCycleDuration:
          invoiceDetaildata?.lifeCycleDuration !== undefined
            ? invoiceDetaildata?.lifeCycleDuration
            : "",
        price: 0,
        depreciationStartDate: undefined,
        warrantyExpDate: undefined,
      });
    }
  }, [childAssetDetail]);

  useEffect(() => {
    setAssetPurDate(purchaseDate);
  }, [purchaseDate]);

  React.useEffect(() => {
    const getLocationList = async () => {
      setLocDropdownLoading(true);
      let res: any = await LocationService.getLocationList(
        currentClient?.id,
        0,
        0,
        ""
      );
      if (res) {
        setLocationList(res?.result);
        setLocDropdownLoading(false);
      } else {
        setLocDropdownLoading(false);
      }
    };
    getLocationList();
  }, [refresh]);

  return (
    <>
      <Drawer
        onClose={() => setOpenChildDrawer(false)}
        open={open}
        width={"40vw"}
        title="Asset Child Detail"
        extra={
          <Space>
            <Button
              onClick={() => {
                assetChildForm.resetFields();
                setOpenChildDrawer(false);
              }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={() => {
                assetChildForm.validateFields().then((val) => {
                  setChildAssetDetail((prev: any) => {
                    let newValues = [...prev];
                    let maxKey =
                      newValues.reduce(
                        (acc: number, rec: any) =>
                          acc > rec.key ? acc : rec.key,
                        0
                      ) + 1;
                    if (selKey > maxKey - 1) {
                      newValues.push({
                        ...val,
                        key: maxKey,
                        warrantyExpDate: val.warrantyExpDate
                          ? dayjs(val.warrantyExpDate).toISOString()
                          : undefined,
                        depreciationStartDate: val.depreciationStartDate
                          ? dayjs(val.depreciationStartDate).toISOString()
                          : undefined,
                      });
                    } else {
                      let selChildValue = {
                        ...val,
                        key: selKey,
                        warrantyExpDate: val.warrantyExpDate
                          ? dayjs(val.warrantyExpDate).toISOString()
                          : undefined,
                        depreciationStartDate: val.depreciationStartDate
                          ? dayjs(val.depreciationStartDate).toISOString()
                          : undefined,
                      };
                      newValues = newValues.map((val: any) =>
                        val.key === selKey ? selChildValue : val
                      );
                    }
                    return newValues;
                  });
                  // setChildAssetDetail();
                  setOpenChildDrawer(false);
                  setCurrentChildData(null);
                });
              }}
            >
              Save Child Detail
            </Button>
          </Space>
        }
      >
        <Form
          name="assetChildDetail"
          layout="vertical"
          form={assetChildForm}
          // initialValues={{ ...currChildData }}
        >
          <Row gutter={6}>
            <Col lg={12} md={12}>
              <Form.Item
                name="childAssetName"
                label="Child Asset Name"
                className="inputboxmb"
                rules={[
                  {
                    required: true,
                    message:
                      "Child asset name is required. Only alphanumeric characters with space, _, / and - are allowed.",
                    pattern: /^[A-Za-z0-9_/()-]+(?:\s[A-Za-z0-9_/()-]+)*$/,
                  },
                  {
                    min: 3,
                    max: 30,
                    message: "Required length is minimum 3 and maximum 30",
                  },
                  {
                    validator: (_) => {
                      if (childAssetAvailable) {
                        return Promise.reject("Name already exists.");
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input onChange={handleChildAssetNameDuplicate}></Input>
              </Form.Item>
            </Col>
            <Col lg={12} md={12}>
              <Form.Item
                name="childAssetNumber"
                label="Asset Number"
                className="inputboxmb"
              >
                <Input disabled />
              </Form.Item>
            </Col>
            <Col lg={12} md={12}>
              <Form.Item
                name="price"
                label={
                  <>
                    <Space>
                      Base Price
                      <Tooltip
                        title="Please input the base purchase price for the Input Tax Credit, else include GST with the base price"
                        placement="top"
                        color="#4b5b95"
                      >
                        <QuestionCircleOutlined />
                      </Tooltip>
                    </Space>
                  </>
                }
                className="inputboxmb"
                rules={[
                  {
                    required: true,
                    message: "Price is required",
                  },
                  {
                    validator: (_, value) => {
                      if (value <= 0) {
                        return Promise.reject(
                          "Price can't be negative or zero."
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  max={999999999}
                  precision={2}
                  onFocus={(e: any) => handleInputFocus(e, assetChildForm)}
                  // onBlur={handlePriceChange}
                  onKeyPress={handleDecimalValues}
                />
              </Form.Item>
            </Col>
            {oldPurchaseType && (
              <Col lg={12} md={12}>
                <Form.Item
                  name="accumulatedDepreciation"
                  label="Accumulated Depreciation"
                  className="inputboxmb"
                >
                  <Input type="number" min={0} />
                </Form.Item>
              </Col>
            )}
            <Col lg={12} md={12}>
              <Form.Item
                name="location"
                label="Location"
                className="inputboxmb"
              >
                <Select
                  style={{ marginBottom: "3px" }}
                  loading={locDropdownLoading}
                  onChange={handleLocation}
                  options={locationList?.map((l: any) => ({
                    value: l.id,
                    label: l.locationName,
                    title: "",
                  }))}
                  dropdownRender={(itemsOption) => (
                    <>
                      {itemsOption}
                      <Divider
                        style={{
                          margin: "5px 0px",
                        }}
                      />
                      <Button
                        style={{ width: "100%" }}
                        icon={<PlusOutlined />}
                        type="link"
                        onClick={() => setIsModelOpen(true)}
                      >
                        Add Location
                      </Button>
                    </>
                  )}
                />
              </Form.Item>
            </Col>
            <Col lg={12} md={12}>
              <Form.Item
                name="model"
                label="Model"
                className="inputboxmb"
                rules={[
                  {
                    min: 0,
                    max: 30,
                    message: "Length must be between 0 and 30",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col lg={12} md={12}>
              <Form.Item
                name="identityCode"
                label="Identity Code"
                className="inputboxmb"
                rules={[
                  {
                    min: 0,
                    max: 30,
                    message: "Length must be between 0 and 30",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col lg={12} md={12}>
              <Form.Item
                name="warrantyExpDate"
                label="Warranty/Guarantee Expire on"
                className="inputboxmb"
              >
                <DatePicker
                  style={{ width: "100%" }}
                  allowClear={true}
                  format={"DD/MM/YYYY"}
                  disabledDate={(current) =>
                    dayjs(assetPurDate) < dayjs(fyPeriod.from)
                      ? current < dayjs(fyPeriod.from)
                      : current < dayjs(assetPurDate).startOf("day")
                  }
                />
              </Form.Item>
            </Col>
            {isDepreciable && (
              <>
                <Col lg={12} md={12}>
                  <Form.Item
                    name="lifeCycleDuration"
                    label="Life Cycle Duration (in year)"
                    className="inputboxmb"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (value && value < 0) {
                            return Promise.reject(
                              "Life cycle duration can't be negative."
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <InputNumber
                      precision={0}
                      min={0}
                      max={100}
                      style={{ width: "100%" }}
                      onFocus={(e: any) => handleInputFocus(e, assetChildForm)}
                    />
                  </Form.Item>
                </Col>
                {depMethod === CalcMethod.StraightLine && (
                  <>
                    <Col lg={12} md={12}>
                      <Form.Item
                        name="residualValue"
                        label="Residual Value"
                        className="inputboxmb"
                        rules={[
                          {
                            required: true,
                            message: "Residual value is required",
                          },
                          {
                            validator: (_, value) => {
                              if (value && value < 0) {
                                return Promise.reject(
                                  "Residual value can't be negative."
                                );
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <InputNumber
                          style={{ width: "100%" }}
                          min={0}
                          max={assetChildForm.getFieldValue("price")}
                          precision={2}
                          onFocus={(e) => {
                            handleInputFocus(e, assetChildForm);
                          }}
                          onKeyPress={handleDecimalValues}
                        />
                      </Form.Item>
                    </Col>
                  </>
                )}
                <Col lg={12} md={12}>
                  <Form.Item
                    name="depreciationStartDate"
                    label="Depreciation Start Date"
                    className="inputboxmb"
                    rules={[
                      {
                        required: true,
                        message: "Depreciation date is required",
                      },
                    ]}
                  >
                    <DatePicker
                      // defaultValue={dayjs()}
                      disabledDate={(current) =>
                        dayjs(assetPurDate) < dayjs(fyPeriod.from)
                          ? current < dayjs(fyPeriod.from)
                          : current < dayjs(assetPurDate).startOf("day")
                      }
                      style={{ width: "100%" }}
                      allowClear={false}
                      format={"DD/MM/YYYY"}
                    />
                  </Form.Item>
                </Col>
              </>
            )}
          </Row>

          <Row gutter={6}>
            <Col span={24}>
              <Form.Item
                name="childAssetDescription"
                label="Description"
                className="inputboxmb"
                rules={[
                  {
                    min: 0,
                    max: 250,
                    message: "Length must be between 0 and 250",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>

      {isModelOpen && (
        <AddLocationModal
          onCancel={() => setIsModelOpen(false)}
          isModelOpen={isModelOpen}
          id={""}
          setRefresh={setRefresh}
        />
      )}
    </>
  );
};

export default AssetChildDetail;
